class MyteaCartRecommendations extends HTMLElement {
  connectedCallback() {
    this.handleCartUpdate = this.refresh.bind(this);
    document.addEventListener('cart:update', this.handleCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this.handleCartUpdate);
    this.abortController?.abort();
  }

  async refresh() {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    this.abortController?.abort();
    this.abortController = new AbortController();

    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(`${root}cart`, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    try {
      const response = await fetch(url, { signal: this.abortController.signal });
      if (!response.ok) return;

      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const replacement = html.querySelector('mytea-cart-recommendations');
      if (!replacement) return;

      this.innerHTML = replacement.innerHTML;
      this.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    } catch (error) {
      if (error.name !== 'AbortError') console.error(error);
    }
  }
}

if (!customElements.get('mytea-cart-recommendations')) {
  customElements.define('mytea-cart-recommendations', MyteaCartRecommendations);
}
